import React, { useState, useEffect } from 'react';
import LoadingScreen from '../../screens/LoadingScreen';
import ColorService from './ColorService';


const ColorInitializer = ({ children }) => {
    const [colorsLoaded, setColorsLoaded] = useState(false);

    useEffect(() => {
        const initializeColors = async () => {
            try {
                const userId = sessionStorage.getItem('user_id');
                
                ColorService.applyColors(ColorService.getDefaultColors());
                
                if (userId) {
                    const userColors = await ColorService.getUserColorPreferencesWithCache(userId);
                    if (userColors) {
                        ColorService.applyColors(userColors);
                    }
                }
                
                ColorService.applyConstantColors();
                
                setColorsLoaded(true);
            } catch (error) {
                console.error('Failed to initialize colors:', error);
                ColorService.applyColors(ColorService.getDefaultColors());
                ColorService.applyConstantColors();
                setColorsLoaded(true);
            }
        };

        initializeColors();
    }, []);

    if (!colorsLoaded) {
        return <LoadingScreen message="Loading theme..." />;
    }

    return <>{children}</>;
};

export default ColorInitializer;